module.exports = __webpack_public_path__ + "static/media/menu.0ed8b807.svg";